var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 57,
    viewBox: "0 0 85 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 83,
    height: 54.4545,
    rx: 4,
    stroke: "#A7A4A4",
    strokeWidth: 2,
    strokeDasharray: "3 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 19C38.0293 19 34 23.0293 34 28C34 32.9707 38.0293 37 43 37C47.9707 37 52 32.9707 52 28C52 23.0293 47.9707 19 43 19ZM47.5 28.9H43.9V32.5H42.1V28.9H38.5V27.1H42.1V23.5H43.9V27.1H47.5V28.9Z",
    fill: "#A7A4A4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCard);
export default __webpack_public_path__ + "static/media/addCard.df1c96d7537eb428d843e9b43900d326.svg";
export { ForwardRef as ReactComponent };